import { Component, OnInit, Input, SimpleChanges, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { Report } from '@usimweb/core/models';
import { ExpansionPanelData } from '@usimweb/core/models';

@Component({
    selector: 'app-report',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss'],
    standalone: false
})
export class ReportComponent implements OnInit, OnChanges {
  @Input() results: Report = {} as Report;

  public avgPressure: number = 0;

  public data: ExpansionPanelData[] = [];

  ngOnInit(): void {
    if (!this.results) {
      this.results = {
        time: 0,
        mass: 0,
        minDensity: 0,
        maxDensity: 0,
        avgDensity: 0,
        minPressure: 0,
        maxPressure: 0,
        fillratio: 0,
        relMassError: 0,
      };
      this.setData();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['results'] && this.results) {
      this.avgPressure = (this.results.minPressure + this.results.maxPressure) / 2;
      this.setData();
    }
  }

  private setData() {
    return (this.data = [
      {
        title: 'Density',
        unit: '[Time: ' + this.results.time + ' s]',
        row: [
          {
            col: [
              { value: this.results.avgDensity, placeholder: 'Average density [kg/m³]' },
              { value: this.results.minDensity, placeholder: 'Minimum density [kg/m³]' },
              { value: this.results.maxDensity, placeholder: 'Maximum density [kg/m³]' },
            ],
          },
        ],
      },
      {
        title: 'Pressure',
        unit: '[Time: ' + this.results.time + ' s]',
        row: [
          {
            col: [
              { value: this.avgPressure || 0, placeholder: 'Average pressure [Pa]' },
              { value: this.results.minPressure || 0, placeholder: 'Minimum pressure [Pa]' },
              { value: this.results.maxPressure || 0, placeholder: 'Maximum pressure [Pa]' },
            ],
          },
        ],
      },
      {
        title: 'Mass & fill ratio',
        unit: '[Time: ' + this.results.time + ' s]',
        row: [
          {
            col: [
              { value: this.results.fillratio || 0, placeholder: 'Fill ratio' },
              { value: this.results.mass || 0, placeholder: 'Mass [kg]' },
              { value: this.results.relMassError || 0, placeholder: 'Relative mass error' },
            ],
          },
        ],
      },
    ]);
  }

  // saveResults() {
  //   this.resultsChanged.emit(this.results);
  // }
}
